import { InputField, TextAreaField } from 'lib/iterable-hook-form';
import {
  StyledVariantFormField,
  StyledVariantTextAreaFormField,
} from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { ComboTextFieldProps } from 'modules/experiments/types';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSchemaValidationErrorTranslations } from 'utils/hooks/useTranslation';
import { ReadOnlyValue } from '../ReadOnlyValue';

export const WebPushTitleBody = ({
  formFields,
  fieldValues,
  isFieldEditable,
}: ComboTextFieldProps) => {
  const {
    formState: { errors },
    trigger,
  } = useFormContext();
  const { zt } = useSchemaValidationErrorTranslations();
  const [titleFormField, bodyFormField] = formFields;
  const fieldsHasError = !!errors[titleFormField.key] || !!errors[bodyFormField.key];
  const errorMessage =
    (errors[titleFormField.key]?.message || errors[bodyFormField.key]?.message)?.toString() ?? '';
  const watchedValues = useWatch({ name: [titleFormField.key, bodyFormField.key] });

  /**
   * Once, an error has occurred start watching for changes
   * in the title and body field. Trigger validation once any one
   * of the fields is updated.
   */
  useEffect(() => {
    if (fieldsHasError) {
      trigger();
    }
  }, [fieldsHasError, watchedValues]);

  return (
    <>
      <StyledVariantFormField
        labelText={titleFormField.label}
        hasError={fieldsHasError}
        errorText={zt(errorMessage)}
        isHorizontalLayout
      >
        {isFieldEditable ? (
          <InputField name={titleFormField.key} autoFocus={titleFormField.isFocused || false} />
        ) : (
          <ReadOnlyValue>{fieldValues[titleFormField.key]}</ReadOnlyValue>
        )}
      </StyledVariantFormField>
      <StyledVariantTextAreaFormField
        labelText={bodyFormField.label}
        hasError={fieldsHasError}
        errorText={zt(errorMessage)}
        isHorizontalLayout
      >
        {isFieldEditable ? (
          <TextAreaField name={bodyFormField.key} />
        ) : (
          <ReadOnlyValue>{fieldValues[bodyFormField.key]}</ReadOnlyValue>
        )}
      </StyledVariantTextAreaFormField>
    </>
  );
};
